// @ts-nocheck FIXME
import ActionModal from '@legacy-components/react/V5/Common/ActionModal';
import PropTypes from 'prop-types';

const DeleteSessionConfirmationModal = (props) => {
  // text depends on whether or not we would be deleting event materials
  let textNode = (
    <div className="v5__body-copy edit-event__modal-row">
      This session information will be removed and cannot be recovered.
    </div>
  );
  if (props.hasEventMaterials) {
    textNode = (
      <div className="v5__body-copy edit-event__modal-row">
        There are facilitator assignments and event materials links attached to
        this session that will be lost. This action cannot be undone.
      </div>
    );
  }

  return (
    <ActionModal
      headlineText="Delete Session?"
      close={props.close}
      spaceFromTop={50}
    >
      {textNode}

      <div className="edit-event__modal-btn-row">
        <button className="v5__btn v5__btn--red" onClick={props.confirm}>
          Delete Session
        </button>
      </div>
    </ActionModal>
  );
};

DeleteSessionConfirmationModal.propTypes = {
  hasEventMaterials: PropTypes.bool,
  close: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
};

export default DeleteSessionConfirmationModal;
